import { useState } from "react";
import { motion } from "framer-motion";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("http://localhost:5000/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (data.success) {
        alert("✅ Message sent successfully!");
        setForm({ name: "", email: "", message: "" });
      } else {
        alert("❌ Failed to send message.");
      }
    } catch (error) {
      console.error(error);
      alert("❌ Something went wrong.");
    }
  };

  return (
    <section id="contact" className="contact-section">
      <h2>Contact Us</h2>

      {/* Modern Intro Text */}
      <motion.div
        className="contact-intro"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
      >
        <h3>Interested in Owning a Villa?</h3>
        <p>
          Become part of <strong>Mardacannes Residence</strong> — a premium
          gated community offering refined design, privacy, and an exclusive
          lifestyle. Get in touch with us to learn more about available villas
          and ownership options.
        </p>
      </motion.div>

      <div className="contact-container">
        {/* Form */}
        <motion.form
          className="contact-form"
          onSubmit={handleSubmit}
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
        >
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={form.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            rows="5"
            placeholder="Message"
            value={form.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Send Message</button>
        </motion.form>

        {/* Office Info */}
        <motion.div
          className="contact-info"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
        >
          <h3>Our Office</h3>
          <p>📍 Mardakan, Absheron, Azerbaijan</p>
          <p>
            📞 <a href="tel:+994551234567">+994 55 123 45 67</a>
          </p>
          <p>
            📧 <a href="mailto:info@mardacannes.com">info@mardacannes.com</a>
          </p>
        </motion.div>
      </div>
    </section>
  );
}
